/**
 * Kullanıcıya gösterilecek hata/bildirim metni.
 *
 * Toast kütüphanesi (vue-toastification) yalnız string'i metin olarak basar;
 * Error/AxiosError nesnesi verilince gövdesi BOŞ bir toast çıkıyordu (bot
 * döngüsündeki `toast.error(e)`). Bu yardımcı her girdiden okunabilir bir
 * Türkçe/sunucu metni üretir ve ASLA boş dönmez.
 *
 * Saf tutulur (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

export const BEKLENMEYEN_HATA_METNI = 'Beklenmeyen bir hata oluştu.';

function metinMi(deger: any): boolean {
    return typeof deger === 'string' && deger.trim() !== '';
}

/** axios'un İngilizce sabit mesajlarını kullanıcıya anlaşılır hale getirir. */
function axiosMesajiniCevir(mesaj: string): string {
    if (mesaj === 'Network Error') {
        return 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.';
    }
    if (/^timeout of \d+ms exceeded$/.test(mesaj)) {
        return 'İstek zaman aşımına uğradı.';
    }
    const durum = /^Request failed with status code (\d+)$/.exec(mesaj);
    if (durum) {
        return 'Sunucu isteği reddetti (HTTP ' + durum[1] + ').';
    }
    return mesaj;
}

export function bildirimMetni(x: any, yedek?: string): string {
    const varsayilan = metinMi(yedek) ? String(yedek).trim() : BEKLENMEYEN_HATA_METNI;

    if (typeof x === 'string') {
        return metinMi(x) ? x.trim() : varsayilan;
    }
    if (x === null || x === undefined || typeof x !== 'object') {
        return varsayilan;
    }

    // axios hatası: sunucunun kendi mesajı varsa o, yoksa axios mesajı.
    const veri: any = x.response ? x.response.data : undefined;
    if (veri && typeof veri === 'object') {
        if (metinMi(veri.message)) {
            return veri.message.trim();
        }
        if (metinMi(veri.error)) {
            return veri.error.trim();
        }
    }
    // Error ya da {message} biçimli düz nesne (UyapRequest reddi, {type, message} ...).
    if (metinMi(x.message)) {
        return x.response || x.isAxiosError ? axiosMesajiniCevir(x.message.trim()) : x.message.trim();
    }
    return varsayilan;
}
